var render, staticRenderFns
import script from "./get_project_details_query.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./get_project_details_query.vue?vue&type=script&lang=js&vue3"
export * from "./get_project_details_query.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./get_project_details_query.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports